import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { getCashCollect } from "../../api/index";
import Moment from "react-moment";
import "moment/locale/id";
import NumberFormat from "react-number-format";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

class CashCollect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tgl_data: new Date().toISOString().split("T")[0], // Default hari ini (YYYY-MM-DD)
      data: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    this.setState({ isLoading: true });
    try {
      const response = await getCashCollect({ tgl_data: this.state.tgl_data });
      console.log("Cash Collect Data:", response.result);
      this.setState({ data: response.result, isLoading: false });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleDateChange = (event) => {
    this.setState({ tgl_data: event.target.value }, this.fetchData);
  };

  exportToExcel = () => {
    const { data } = this.state;

    if (data.length === 0) {
      alert("Tidak ada data untuk diekspor!");
      return;
    }

    let exportData = [];

    data.forEach((shift) => {
      // Pisahkan transaksi "CASH"
      const cashTransactions = shift.data.filter(
        (item) => item.bankname.toLowerCase() === "cash"
      );

      // Tambahkan data transaksi "CASH" ke dalam shift
      if (cashTransactions.length > 0) {
        exportData.push({
          Shift: shift.shift,
          Tanggal: "", // Kosongkan agar terlihat sebagai judul
          // Customer: "",
          // Produk: "",
          Bank: "TOTAL CASH",
          "Jumlah (Rp)": cashTransactions.reduce(
            (sum, item) => sum + item.subtotal,
            0
          ),
        });

        cashTransactions.forEach((item) => {
          exportData.push({
            Shift: shift.shift,
            Tanggal: item.tgl_data,
            // Customer: item.name_customer,
            // Produk: item.name_roomproduct,
            Bank: item.bankname,
            "Jumlah (Rp)": item.subtotal,
          });
        });
      }
    });

    // Tambahkan transaksi selain "CASH"
    let otherTransactions = [];
    data.forEach((shift) => {
      shift.data
        .filter((item) => item.bankname.toLowerCase() !== "cash")
        .forEach((item) => otherTransactions.push(item));
    });

    // Urutkan transaksi lainnya berdasarkan waktu `tgl_data`
    otherTransactions.sort(
      (a, b) => new Date(a.tgl_data) - new Date(b.tgl_data)
    );

    if (otherTransactions.length > 0) {
      exportData.push({
        Shift: "NON-CASH",
        Tanggal: "",
        // Customer: "",
        // Produk: "",
        Bank: "TOTAL NON-CASH",
        "Jumlah (Rp)": otherTransactions.reduce(
          (sum, item) => sum + item.subtotal,
          0
        ),
      });

      otherTransactions.forEach((item) => {
        exportData.push({
          Shift: "NON-CASH",
          Tanggal: item.tgl_data,
          // Customer: item.name_customer,
          // Produk: item.name_roomproduct,
          Bank: item.bankname,
          "Jumlah (Rp)": item.subtotal,
        });
      });
    }

    // Buat worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Buat workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cash Collect");

    // Simpan file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(dataBlob, `Cash_Collect_${this.state.tgl_data}.xlsx`);
  };

  renderData() {
    const { data } = this.state;
    let cashByShift = {};
    let otherTransactions = [];

    // Pisahkan transaksi dengan bankname "CASH" ke dalam shift masing-masing
    data.forEach((shift) => {
      const cashTransactions = shift.data.filter(
        (item) => item.bankname.toLowerCase() === "cash"
      );

      if (cashTransactions.length > 0) {
        cashByShift[shift.shift] = {
          total: cashTransactions.reduce((sum, item) => sum + item.subtotal, 0),
          data: cashTransactions,
        };
      }

      // Masukkan transaksi lain yang bukan "CASH" ke dalam daftar transaksi lainnya
      shift.data
        .filter((item) => item.bankname.toLowerCase() !== "cash")
        .forEach((item) => otherTransactions.push(item));
    });

    // Urutkan transaksi lainnya berdasarkan waktu `tgl_data`
    otherTransactions.sort((a, b) =>
      new Date(a.tgl_data) > new Date(b.tgl_data) ? 1 : -1
    );

    return (
      <>
        {Object.keys(cashByShift).map((shiftName) => (
          <div key={shiftName} className="shift-section">
            <h2>{shiftName}</h2>
            <p className="total-cash">
              Total Cash:{" "}
              <NumberFormat
                value={cashByShift[shiftName].total}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"Rp "}
              />
            </p>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  {/* <th>Customer</th>
                  <th>Produk</th> */}
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                {cashByShift[shiftName].data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      <Moment format="DD MMMM YYYY HH:mm" locale="id">
                        {item.tgl_data}
                      </Moment>
                    </td>
                    {/* <td>{item.name_customer}</td>
                    <td>{item.name_roomproduct}</td> */}
                    <td>
                      <NumberFormat
                        value={item.subtotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"Rp "}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

        {otherTransactions.length > 0 && (
          <>
            <h2>Transaksi Non-Cash</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  {/* <th>Customer</th>
                  <th>Produk</th> */}
                  <th>Bank</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                {otherTransactions.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      <Moment format="DD MMMM YYYY HH:mm" locale="id">
                        {item.tgl_data}
                      </Moment>
                    </td>
                    {/* <td>{item.name_customer}</td>
                    <td>{item.name_roomproduct}</td> */}
                    <td>{item.bankname}</td>
                    <td>
                      <NumberFormat
                        value={item.subtotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"Rp "}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </>
    );
  }

  render() {
    return (
      <div className="cash-collect-container">
        <h1>Cash Collect</h1>

        <input
          type="date"
          value={this.state.tgl_data}
          onChange={this.handleDateChange}
          className="form-control mb-3"
        />

        <button className="btn btn-success mb-3" onClick={this.exportToExcel}>
          Export ke Excel
        </button>

        {this.state.isLoading ? (
          <p className="loading-text">Generating Cash Collect . . .</p>
        ) : (
          this.renderData()
        )}
      </div>
    );
  }
}

export default withRouter(CashCollect);
